import { isMobile } from './utils/platformCheck';
import { GameNames } from "../store/slices/GameTypes";
import { setCurrentScene } from "../store/slices/gameObjectSlice";
import { store } from "../store/store";
import { Action, Node } from "./Actions/Action";
import Game from "./Game";

export function jump(func: any, name: string, ...args: any): Promise<Node<unknown>> {
    if (!func || name.includes("TODO")) {
        throw new Error("must define a function as the first parameter");
    }
    if (!isMobile() && process.env.NODE_ENV === "development") {
        if (func?.name !== name) {
            throw new Error(`jump names not matching! ${func.name} - ${name}`);

        }
    }
    return new Action({}, GameNames.JUMP).run(
        function jump(callback: () => void) {
            // console.log("current scene set:", name);
            store.dispatch(setCurrentScene(name));
            return func(args);
        }
    );

}